import { useMutation } from '@apollo/client'
import { IMPERSONATE_B2B_CUSTOMER } from '@/containers/B2BCustomers/B2BCustomersQueries'
import { useCallback, useEffect } from 'react'
import { useLanguage } from '@/context/LanguageContext'
import { jwtDecode } from 'jwt-decode'
import { B2B_PORTAL_LANGUAGES } from '@/containers/Pages/pagePublicUrl'

const B2B_PORTAL_URL =
  process.env.REACT_APP_B2B_PORTAL_URL || 'http://localhost:8090'

const useImpersonateB2BPortal = () => {
  const [impersonateLazy, { loading, error, data }] = useMutation(
    IMPERSONATE_B2B_CUSTOMER,
    {
      fetchPolicy: 'network-only',
    }
  )
  const { language } = useLanguage()

  const getCurrentUserId = () => {
    const token = localStorage.getItem('furnisystems-token')
    if (!token) return null
    try {
      const decoded = jwtDecode(token) as any
      return decoded.id
    } catch (e) {
      return null
    }
  }

  const impersonatePortal = useCallback(
    (customerId: number) => {
      const managerId = getCurrentUserId()
      if (!managerId) {
        console.error('Unable to get current user ID')
        return
      }
      impersonateLazy({
        variables: {
          impersonateB2BCustomerId: customerId,
          managerId,
        },
      })
    },
    [impersonateLazy]
  )

  useEffect(() => {
    if (data) {
      // The portal only serves en/fr/de; the admin's default language can be
      // `lt`, which the portal middleware rewrites to /en/lt/... and 404s.
      const portalLanguage = (B2B_PORTAL_LANGUAGES as readonly string[]).includes(
        language
      )
        ? language
        : 'en'
      const url = `${B2B_PORTAL_URL}/${portalLanguage}/auth/impersonate?token=${data.impersonateB2BCustomer}`
      window.open(url, '_blank', 'noreferrer')
    }
  }, [data, language])

  return { impersonatePortal, loading, error, data }
}

export default useImpersonateB2BPortal
